import { render, staticRenderFns } from "./SocialSignIn.vue?vue&type=template&id=1ca081a8&scoped=true&"
import script from "./SocialSignIn.vue?vue&type=script&lang=js&"
export * from "./SocialSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca081a8",
  null
  
)

export default component.exports